import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'public/environments/environment';
import { RefreshActionEnum } from '../../models/enums/RefreshActionEnum';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  refreshList = new BehaviorSubject<RefreshActionEnum | boolean>(false);
  closeDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(params: any): any {
    return this.http.get(`${environment.apiUrl}/users/ListInternalOrExternalUsers`, { params });
  }

  addUser(data: any, userId?: any) {
    if (userId) {
      return this.http.put(`${environment.apiUrl}/users/UpdateInernalOrExternalUser`, data);
    } else {
      return this.http.post(`${environment.apiUrl}/users/AddInernalOrExternalUser`, data);
    }
  }

  deleteUser(id: any) {
    return this.http.delete(`${environment.apiUrl}/users/DeleteUser/${id}`);
  }

  getUserDetails(id: any) {
    return this.http.get(`${environment.apiUrl}/users/GetUserProfile?id=${id}`);
  }

  changeStatus(id: any, status: any) {
    return this.http.get(`${environment.apiUrl}/users/ChangeUserStatus?id=${id}&status=${status}`);
  }

  resendVerification(id: any) {
    return this.http.get(`${environment.apiUrl}/users/ReSendActivationEmail?id=${id}`);
  }

  getSystemRoles() {
    return this.http.get(`${environment.apiUrl}/SystemUser/GetSystemRoles`)
  }

}
